import { ChevronRight } from 'lucide-react'
import React from 'react'

export interface BreadcrumbItem {
  label: string
  id?: string
  clickable?: boolean
}

interface PanelBreadcrumbsProps {
  items: BreadcrumbItem[]
  onNavigate?: (index: number) => void
  maxWidth?: string
  className?: string
}

export function PanelBreadcrumbs({
  items,
  onNavigate,
  maxWidth = 'max-w-md',
  className = '',
}: PanelBreadcrumbsProps) {
  if (items.length === 0) {
    return null
  }

  const handleItemClick = (index: number, item: BreadcrumbItem) => {
    if (item.clickable !== false && onNavigate) {
      onNavigate(index)
    }
  }

  return (
    <div className={`flex items-center gap-1 ${maxWidth} ${className}`}>
      <div className="flex items-center gap-1 overflow-hidden">
        {items.map((item, index) => (
          <React.Fragment key={item.id || index}>
            {/* Breadcrumb Item */}
            <div className="flex min-w-0 items-center gap-1">
              {item.clickable !== false && onNavigate && index < items.length - 1 ? (
                <button
                  onClick={() => handleItemClick(index, item)}
                  className="truncate text-sm font-medium text-gray-600 transition-colors hover:text-gray-900"
                  type="button"
                  title={item.label}
                >
                  {item.label}
                </button>
              ) : (
                <span
                  className={`truncate text-sm font-medium ${
                    index === items.length - 1
                      ? 'text-gray-900' // Current/last item is darker
                      : 'text-gray-600'
                  }`}
                  title={item.label}
                >
                  {item.label}
                </span>
              )}

              {/* Separator */}
              {index < items.length - 1 && (
                <ChevronRight className="h-3 w-3 flex-shrink-0 text-gray-400" />
              )}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}
